module.exports = __webpack_public_path__ + "media/bootstrap-icons/alarm-979f1ac5.svg";